import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { CommonModule } from '@angular/common';
import {ShareModule} from "./common/components/share.module";
import {CarouselModule} from 'primeng/carousel';
import {HttpClientModule} from '@angular/common/http';
import { LayoutComponent } from './common/layouts/layout-page/layout.component';
import { LayoutMapComponent } from './common/layouts/layout-map/layout-map.component';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { MasterDataService } from 'src/api/masterData.service';
import { AddressService, GroupService } from 'src/api/api';
import { AuthKeycloackService } from './common/services/auth.service';
import { ToastrModule } from 'ngx-toastr';

function initializeKeycloak(keycloak: KeycloakService) {
  const { keycloakConfig } = environment;
  return () =>
    keycloak.init({
      config: keycloakConfig,
      initOptions: {
        onLoad: "check-sso",
        checkLoginIframe: false
      },
      loadUserProfileAtStartUp: false,
      enableBearerInterceptor: true,

      bearerPrefix: 'Bearer',
      bearerExcludedUrls: [
          '/autocomplete',
          '/reverse',
          '/search',
          ]
    });
}
function testKeycloak(keycloak: KeycloakService) {
  const { keycloakConfig } = environment;
  return () =>
    keycloak.init();
}
@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    LayoutMapComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ShareModule,
    RouterModule,
    KeycloakAngularModule,
     ToastrModule.forRoot(),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    },
    MasterDataService,
    GroupService,
    AddressService

  ],
  bootstrap: [AppComponent]

})
export class AppModule { }
